<template>
  <form @submit.prevent="recover">
    <error-indicator :error="error" v-if="error"/>
    <p>
      Geben Sie die Login-E-Mail Ihres Benutzers ein und klicken Sie auf „Zurücksetzen". Ein neues Passwort wird in Kürze automatisch verschickt.<br/>
      Berücksichtigen Sie bitte, dass es bei der Übertragung auch zu Wartezeiten kommen kann. Sollte sich die Benachrichtigung nicht im Posteingang befinden, kontrollieren Sie ebenfalls Ihren Spamverdacht-Ordner.
    </p>
    <div class="field">
      <div class="ui left icon input">
        <i class="user icon"></i>
        <input type="text" name="login" placeholder="E-Mail/Benutzername" v-model="username">
      </div>
    </div>
    
    <div class="ui orange message" v-if="success === false">
      <i class="close icon" @click="success = null"/>
      <div class="header">
        Zurücksetzen fehlgeschlagen
      </div>
      Es konnte kein Benutzer mit diesem Login gefunden werden (oder ein Zurücksetzen des Passworts ist nicht möglich [z.B. durch externen EDWIN-Login]).
    </div>
    
    <div class="ui green message" v-if="success === true">
      <i class="close icon" @click="success = null"/>
      <div class="header">
        Passwort erfolgreich zurückgesetzt
      </div>
      Eine E-Mail mit dem neuen Passwort ist zu Ihnen unterwegs!
      <router-link to="/login">Zum Login</router-link>
    </div>
    
    
    <button type="submit" class="ui fluid green submit button" v-if="success !== true">Zurücksetzen</button>
    <loading-indicator v-if="loading"/>

  </form>
</template>

<script>
import RecoverMixin from '../mixins/recover'
import LoadingIndicator from '~shared/components/loading-indicator.vue'
import ErrorIndicator from '~shared/components/error-indicator.vue'

export default {
  mixins: [RecoverMixin],
  components: {
    LoadingIndicator,
    ErrorIndicator
  }
}
</script>

<style>


.recover{
  margin-bottom: 10px;
  display: block;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// page.vue?3d8e64e8